export const defaultTitle = 'How injury <br/> <i>cases work</i>';
